import { AdminAppState, PlaceEntry } from '../../state';
import { getPlace } from './get-place';

export const getPlaceDescription = (placeKey: string) => (
  store: AdminAppState,
): PlaceEntry['place']['description'] => getPlace(placeKey)(store).description;
